import { composeWithDevTools } from '@redux-devtools/extension';
import { applyMiddleware, createStore, type Store } from 'redux';
import createSagaMiddleware, { END } from 'redux-saga';
import type { ActionType } from 'typesafe-actions';
import type { AppState } from './app-state';
import reducer from './reducer';
import router from './router';
import rootSaga from './saga';
import type { setMonacoCodeEditor } from './schema/slice';

const sagaMiddleware = createSagaMiddleware();

const actionSanitizer = (action: ActionType<any>) => {
  switch (action.type) {
    case 'schema/SET_CODE_EDITOR':
      return (action as unknown as ActionType<typeof setMonacoCodeEditor>).payload
        ? { ...action, payload: '<<MONACO_EDITOR>>' }
        : action;
    default:
      return action;
  }
};

const stateSanitizer = (state: AppState) => {
  return state.schema.monacoCodeEditor
    ? {
        ...state,
        schema: { ...state.schema, monacoCodeEditor: '<<MONACO_EDITOR>>' }
      }
    : state;
};

const composeEnhancers = composeWithDevTools({
  actionSanitizer,
  stateSanitizer: stateSanitizer as (state: any, index: number) => any
});
const enhancer = composeEnhancers(router.enhancer, applyMiddleware(sagaMiddleware, router.middleware));

export function createReduxStore(initialState: AppState) {
  const store: Store<AppState> = createStore(reducer, initialState as any, enhancer);

  if (import.meta.hot) {
    import.meta.hot.accept('./reducer', (newModule) => {
      if (newModule) {
        store.replaceReducer(newModule.default);
      }
    });
  }

  sagaMiddleware.run(rootSaga);

  // `close` is not in the Store type but it's there
  (store as any).close = () => store.dispatch(END);

  return store;
}
